angular.module('aprima-core-ui').controller('apIcdCodeModalCtrl', ['$scope', '$uibModalInstance', 'DiagnosisRepository', '$q', '_', 'searchParams',
    function ($scope, $uibModalInstance, DiagnosisRepository, $q, _, searchParams) {
        'use strict';

        $scope.loading = true;
        $scope.modifierIndex = 0;

        var modifierPromise = DiagnosisRepository.getModifiers();
        var codePromise;

        function searchForCode(searchCode) {
            $scope.loading = true;
            searchCode = _.trim(searchCode);

            if ($scope.codeType === 'ICD10') {
                $scope.code = searchCode.substring(0, searchCode.length - 1);
                $scope.displayCode = $scope.code + 'X';
            }
            else {
                $scope.code = $scope.displayCode = searchCode;
            }

            $scope.topLevel = _.endsWith($scope.code, '.');

            if ($scope.topLevel) {
                codePromise = DiagnosisRepository.getDiagnoses($scope.code.substring(0, $scope.code.length - 1), 500);
            }
            else {
                codePromise = DiagnosisRepository.getDiagnoses($scope.code, 500, $scope.codeType);
            }

            performSearch();
        }

        function performSearch() {
            $q.all([modifierPromise, codePromise]).then(function (results) {
                var allModifiers = results[0].plain();
                var allCodes = results[1].plain();

                if (allCodes.length === 1) {
                    $scope.diagnosisSelected(allCodes[0]);
                    return;
                }

                $scope.allCodes = allCodes;
                $scope.filteredCodes = $scope.allCodes;

                var codeModifiers = _.chain(allCodes)
                    .map('Modifiers')
                    .flatten()
                    .uniq()
                    .value();

                var matchedCategories = _.filter(allModifiers, function (category) {
                    var matched = _.chain(category.Modifiers)
                        .map('Code')
                        .intersection(codeModifiers)
                        .some()
                        .value();

                    return matched;
                });

                $scope.modifierCategories = _.cloneDeep(_.sortBy(matchedCategories, 'Description'));
                $scope.selectedModifiers = [];
                updateCategories();

                $scope.loading = false;
            }).catch(function (response) {
                $scope.addHttpError(response);
            });
        }

        $scope.codeType = searchParams.codeType;
        searchForCode(searchParams.code);

        $scope.searchLevelUp = function searchLevelUp() {
            if (!$scope.topLevel) {
                searchForCode($scope.code);
            }
        };

        function updateCategories() {
            var remainingModifiers = _.chain($scope.filteredCodes)
                .map('Modifiers')
                .flatten()
                .uniq()
                .value();

            _.chain($scope.modifierCategories)
                .map('Modifiers')
                .flatten()
                .forEach(function (modifier) {
                    modifier.disabled = !_(remainingModifiers).includes(modifier.Code);
                });
        }

        $scope.modifierSelected = function (modifier) {
            if (!modifier.disabled) {
                if (_($scope.selectedModifiers).includes(modifier.Code)) {
                    _.pull($scope.selectedModifiers, modifier.Code);
                    modifier.isSelected = false;
                }
                else {
                    $scope.selectedModifiers.push(modifier.Code);
                    modifier.isSelected = true;
                }

                filterCodes();
                updateCategories();
            }
        };

        function filterCodes() {
            $scope.filteredCodes = _.filter($scope.allCodes, function (code) {
                return !_.chain($scope.selectedModifiers)
                    .difference(code.Modifiers)
                    .some()
                    .value();
            });
        }

        $scope.diagnosisSelected = function (diagnosis) {
            $uibModalInstance.close(diagnosis);
        };

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);